import { MenuList } from "./MenuList";
import { isAuthenticated, getUserSession } from "./Session";

export const VerifyPermission = () => {

    const session = getUserSession();
    const menuFunctionalities = MenuList(session.menu).filter((menu) => { return menu.type != "2" });

    let currentFunctionality;

    const currentUrl = window.location.href;
    let funcPath = '/' + currentUrl.split('/').slice(3).join('/');

    if (!funcPath.includes('#')) {
        funcPath += '#';
    }

    const pathExists = menuFunctionalities.some(functionality => {

        if (functionality.path) {
            if (!functionality.path.includes('#')) {
                functionality.path += '#';
            }

            const functionalityPathParts = funcPath.split('/');
            const functionalityPathPrefix = functionality.prefix;

            if (functionalityPathParts.includes(functionalityPathPrefix)) {
                currentFunctionality = functionality;
                return true;
            }
        }

        return false;
    });

    if (!pathExists) {
        let direcionamento = currentUrl.split('/');
        direcionamento = `${direcionamento[0]}//${direcionamento[2]}${menuFunctionalities[0].path}`;

        if (funcPath === "/#") {
            return false;
        }

        window.location.replace(direcionamento);
    }

    return currentFunctionality || false;
};

export const VerifyAction = (key, permissionType = "canView") => {
    console.log("AQUI")
    if(!isAuthenticated()) return false;
    
    
    // Agora ela chama a função vizinha por conta própria
    const currentFunctionality = VerifyPermission();
    
    // Se não encontrou a tela na sessão do usuário ou a tela não possuir ações cadastradas
    if (!currentFunctionality || !currentFunctionality.children) return false;
    
    // Procura o filho ("Ação") com a chave idêntica
    const action = currentFunctionality.children.find(
        (child) => String(child.type) === "2" && child.key === key
    );

    // Se estiver ausente, bloqueia o acesso
    if (!action) return false;

    // Retorna se o usuário marcou aquele privilégio (ex: canView) lá no Perfis de Acesso
    return action[permissionType] === true;
};